import { Modal, Button, Form } from 'react-bootstrap'
import { Formik, Field } from 'formik'
import { useIntl } from 'react-intl'
import { AdminInput, UserRole } from '../../models/models'
import { requestEditProfile } from '../../requests/requests'
import { ManagementUserEdit } from '../../models/managementUsers'
import { ParseUserRolesFromStrings } from '../../helpers/utils'

export function EditUserModal({
  user,
  show,
  onHide,
  refetch,
}) {
  const intl = useIntl()
  const addInputs = () => {
    let arr: AdminInput[] = []
    arr.push({
      uniqueId: 'editModalFirstName',
      wrapperClass: 'mb-8',
      name: `firstName`,
      type: 'text',
      labelKey: 'ADD_USER.FIRST_NAME',
      labelName: '',
      required: true,
      initialValue: '',
      helperText: intl.formatMessage({ id: 'ADD_USER.FIRST_NAME_PLACEHOLDER' }),
    })
    arr.push({
      uniqueId: 'editModalLastName',
      wrapperClass: 'mb-8',
      name: `lastName`,
      type: 'text',
      labelKey: 'ADD_USER.LAST_NAME',
      labelName: '',
      required: true,
      initialValue: '',
      helperText: intl.formatMessage({ id: 'ADD_USER.FIRST_NAME_PLACEHOLDER' }),
    })
    arr.push({
      uniqueId: 'editModalEmail',
      wrapperClass: 'mb-8',
      name: `email`,
      type: 'email',
      labelKey: 'ADD_USER.EMAIL',
      labelName: '',
      required: true,
      initialValue: '',
      helperText: intl.formatMessage({ id: 'ADD_USER.EMAIL_PLACEHOLDER' }),
      disabled: true,
      className: 'form-control border-0 text-black'
    })
    arr.push({
      uniqueId: 'editModalRoleConfronta',
      wrapperClass: '',
      name: `role`,
      type: 'radio',
      labelKey: '',
      labelName: 'Confronta',
      required: true,
      initialValue: '',
      helperText: intl.formatMessage({ id: 'ADD_USER.ROLE_CONFRONTA_HELPERTEXT' }),
      value: UserRole.Confronta+''
    })
    arr.push({
      uniqueId: 'editModalRoleCommercial',
      wrapperClass: '',
      name: `role`,
      type: 'radio',
      labelKey: '',
      labelName: 'Comercial',
      required: false,
      initialValue: '',
      helperText: intl.formatMessage({ id: 'ADD_USER.ROLE_COMMERCIAL_HELPERTEXT' }),
      value: UserRole.Comercial+'',
      childrens: [
        {
          uniqueId: 'editModalSageCode',
          wrapperClass: 'mt-3',
          name: `sageCode`,
          type: 'text',
          labelKey: '',
          labelName: '',
          required: false,
          initialValue: '',
          placeholder: 'Sage Code',
          conditionalShow: '#editModalRoleCommercial'
        }
      ]
    })
    arr.push({
      uniqueId: 'editModalRoleMarketing',
      wrapperClass: '',
      name: `role`,
      type: 'radio',
      labelKey: '',
      labelName: 'Marketing',
      required: false,
      initialValue: '',
      helperText: intl.formatMessage({ id: 'ADD_USER.ROLE_MARKETING_HELPERTEXT' }),
      value: UserRole.Marketing+''
    })
    arr.push({
      uniqueId: 'editModalRoleBackOffice',
      wrapperClass: '',
      name: `role`,
      type: 'radio',
      labelKey: '',
      labelName: 'Back Office',
      required: false,
      initialValue: '',
      helperText: intl.formatMessage({ id: 'ADD_USER.ROLE_BACKOFFICE_HELPERTEXT' }),
      value: UserRole.BackOffice+''
    })
    arr.push({
      uniqueId: 'editModalRoleTIC',
      wrapperClass: '',
      name: `role`,
      type: 'radio',
      labelKey: '',
      labelName: 'TIC',
      required: false,
      initialValue: '',
      helperText: intl.formatMessage({ id: 'ADD_USER.ROLE_TIC_HELPERTEXT' }),
      value: UserRole.TIC+''
    })
    return arr
  }
  const generateInput = (el) => {
    if (el.conditionalShow) {
      setInterval(() => {
        const elementConditional = document.querySelector(el.conditionalShow);
        if (elementConditional) {
          const hideElementSelector = '#' + el.uniqueId;
          if (!elementConditional.checked) {
            const elementToHide = document.querySelector(hideElementSelector);
            if (elementToHide) {
              elementToHide.classList.add('opacity-0', 'position-absolute')
            }
          } else {
            const elementToHide = document.querySelector(hideElementSelector);
            if (elementToHide) {
              elementToHide.classList.remove('opacity-0', 'position-absolute')
            }
          }
        }
      }, 500)
    }
    return <div key={el.uniqueId} className={`${el.wrapperClass}`}>
      <Form.Group
        className={
          'd-flex flex-column'
        }
      >
        {el.type !== 'radio' && (el.labelKey.length > 0 || el.labelName.length > 0) &&
          <Form.Label className='fs-4 text-black' htmlFor={el.uniqueId}>
            {el.labelKey.length > 0 ? intl.formatMessage({ id: el.labelKey }) : el.labelName}&nbsp;{el.required ? '*' : ''}
          </Form.Label>
        }

        {el.type !== `radio` && (
          <Field
            type={el.type}
            name={el.name}
            className={
              el.className ? el.className : 'form-control bg-light border-0 text-black'
            }
            required={el.required}
            id={el.uniqueId}
            maxLength={100}
            placeholder={el.placeholder ? el.placeholder : ''}
            disabled={el.disabled}
          />
        )}

        {el.type === 'radio' && <>
          {el.showSectionLabel ? <Form.Label className='fs-4 text-black'>{el.showSectionLabel}&nbsp;{el.required ? '*' : ''}</Form.Label> : ''}

          {el.showSectionPlaceholder ? <span className="text-gray-400">{el.showSectionPlaceholder}</span> : ''}

          <div className={`form-check ${el.showSectionPlaceholder ? 'mt-5' : ''}`}>
            <Field
              type={el.type}
              name={el.name}
              className={
                el.className ? el.className : 'form-check-input mt-2'
              }
              required={el.required}
              id={el.uniqueId}
              maxLength={100}
              value={el.value}
              placeholder={el.placeholder ? el.placeholder : ''}
            />
            <Form.Label className='fs-6 text-black form-check-label ms-2' htmlFor={el.uniqueId}>
              {el.labelKey.length > 0 ? intl.formatMessage({ id: el.labelKey }) : el.labelName}&nbsp;

              <div className='text-muted'>{el.helperText}</div>

              <div>{el.childrens ? el.childrens.map((elChildren => {
                return generateInput(elChildren)
              })) : ''}</div>
            </Form.Label>
          </div>
        </>}

        {el.type !== 'radio' &&
          <span className='text-gray-400 mt-2'>{el.helperText}</span>}
      </Form.Group>
    </div>
  }
  const initialValuesProductExtension = () => {
    let initial = user
    if (!user.businessName) {
      user.businessName = '';
    }
    if (user.roles && user.roles.length > 0) {
       // Fix for edit initial value
      const userRoles = ParseUserRolesFromStrings(user.roles)
      user.role = userRoles[0]+''
    }
    return initial
  }

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName='modal-dialog modal-dialog-centered mw-900px'
    >
      <Modal.Header closeButton>
        <Modal.Title>
          <h2 className='text-black'>
            {intl.formatMessage({ id: 'LIST_USERS.EDIT_USER' })}
          </h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='modal-body py-lg-10 px-lg-20'>
        <Formik
          initialValues={initialValuesProductExtension()}
          onSubmit={async (values:any) => {
            values.id = user.id;
            values.role = parseInt(values.role)
            const editProfileObj: ManagementUserEdit = values as ManagementUserEdit
            await requestEditProfile(editProfileObj)
            refetch()
            onHide()
          }}
        >
          {({ handleSubmit }) => (
            <Form onSubmit={handleSubmit}>
              {addInputs().map((el) => (
                generateInput(el)
              ))}
              <Button variant='primary' type='submit' className='w-100 mt-8'>
                {intl.formatMessage({ id: 'BUTTON.EDIT' })}
              </Button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  )
}
